import de from './de'

const fr: typeof de = {
  title: 'Comment êtes-vous parmi les riches?',
  subline:
    'Découvrez où vous en pensez dans la société en fonction de vos revenus et de votre patrimoine.',
  publication: 'Publié le 27 décembre 2023',
  //form
  form_title: 'Vos données',
  form_disclaimer: 'Les données personnelles ne sont pas stockées.',
  income_label: 'Votre revenu brut annuel',
  income_subline_1: 'Revenu brut individuel par an y ',
  income_subline_2: 'compris les revenus du capital et les rentes',
  income_info:
    'Si vous vivez dans un ménage avec plusieurs personnes et que vous souhaitez calculer cette situation, divisez le revenu brut total du ménage par le nombre de personnes adultes.',
  vermoegen_label: 'Votre fortune',
  vermoegen_subline_1:
    "Tous les biens personnels tels que l'épargne, les véhicules, l'immobilier, les actions, etc., ",
  vermoegen_subline_2:
    "y compris les avoirs de la caisse de pension et le troisième pilier, après déduction de l'ensemble des dettes.",
  vermoegen_info:
    'Si vous vivez dans un ménage de plusieurs personnes, divisez la fortune totale commune par le nombre d’adultes.',
  adults_in_household: 'Personnes adultes dans le ménage',
  kids_in_household: 'Enfants dans le ménage',
  canton: 'Dans quel canton habitez-vous?',
  age: 'Votre âge',
  age_group: "Votre classe d'âge",
  show_chart: 'Afficher',
  // Group Display Bar
  group_display_bar_title:
    'Vous appartenez à la catégorie de richesse suivante',
  group_display_bar_middle_income: 'Votre revenu',
  group_display_bar_middle_savings: 'Votre fortune',
  group_display_bar_x_axis_title: 'Part des contribuables en Suisse',
  //groups
  group_1: 'Classe aisée',
  group_2: 'Classe moyenne supérieure',
  group_3: 'Classe moyenne',
  group_4: 'Classe moyenne inférieure',
  group_5: 'Risques de pauvreté',
  group_6: 'Précarité',

  // EINKOMMEN CHART
  einkommen_chart_title: 'Population répartie en 20 groupes de revenus égaux ',
  lower_5: '5% les plus bas',
  upper_5: '5% les plus hauts',
  y_axis_title_income: 'Vous appartenez à la catégorie de revenus suivante',
  y_axis_subline_1_income: 'Revenu brut par an en francs',
  einkommen_chart_you: 'Vous',

  income_reading_1:
    'Avec votre revenu, vous faites partie des 5% de la population suisse ayant le revenu le plus bas.',
  income_reading_2:
    " Les 5% ayant le revenu le plus haut ont un revenu moyen de 353'000 francs par an.",
  income_reading_3:
    'Vous appartenez aux 5% de la population suisse avec un revenu moyen de {{value}} Fr.',
  income_reading_4: '. Les 5% supérieurs ont un revenu moyen de {{value}} Fr.',
  income_reading_5:
    'Vous appartenez aux 5% de la population suisse avec un revenu moyen de {{value}} Fr.',
  income_reading_6:
    '{{value}}% ont un revenu supérieur à votre revenu. Les 5% supérieurs ont un revenu moyen de {{value1}} Fr.',
  income_annotation:
    'Vous appartenez à cette catégorie. 70% ont un revenu supérieur à votre revenu.',
  // VERMOGENSCHART
  vermoegen_chart_title: 'Population répartie en 20 groupes de revenus égaux ',
  y_axis_title_wealth: 'Vous appartenez à la catégorie de fortune suivante',
  y_axis_subline_1_wealth: 'Patrimoine en incluant la retraite en Fr.',
  wealth_reading_1:
    'Vous faites partie des 5% de la population ayant une fortune moyenne de {{value}} de francs. ',
  wealth_reading_2:
    '{{value}} % de la population ont plus d’argent que vous. Les 5% les plus riches possèdent une fortune moyenne de 6,2 millions de francs.',
  source: 'Source',
  age_group_1: '18-65 ans',
  age_group_2: '65 ans et plus',
}
export default fr
